import React from 'react'

import { FlowChartAction } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartActionNode'

import * as styles from './ActionItem.styles'

interface ActionItemProps {
  actionItem: FlowChartAction
  isLast: boolean
}

export const ActionItem = ({ actionItem, isLast }: ActionItemProps) => {
  return (
    <view style={styles.ItemWrapper}>
      <richtext style={styles.NameStyle} text={actionItem.name} />
      {Boolean(actionItem.description) && (
        <richtext style={styles.DescriptionStyle} text={actionItem.description} />
      )}
      <view style={isLast ? styles.BorderBottomLastStyle : styles.BorderBottomStyle} />
    </view>
  )
}
